import { render, staticRenderFns } from "./StepPracticeComponent.vue?vue&type=template&id=7c22f226"
import script from "./StepPracticeComponent.vue?vue&type=script&lang=js"
export * from "./StepPracticeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports